import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../redux/SettingAction";
import { ApiStatusTypeEnum } from "../../../../enumeration/ApiStatusTypeEnum";
import { Overlay } from "../../../common/components/Overlay";

export const Voucher = ({ setIsShow, isShow, setSwalProps }) => {
  const intl = useIntl();
  const [voucherCode, setVoucherCode] = useState("");
  const dispatch = useDispatch();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);

  useEffect(() => {
    if (isShow) {
      setVoucherCode("");

      return () => dispatch(actions.clearVoucherStep1());
    }
  }, [isShow]);

  const onClaim = () => {
    dispatch(
      actions.claimVoucherStep1({
        action: "claimvoucher_step1",
        vouchercode: voucherCode,
      })
    );
  };

  const handleVoucherClick = (companyCode) => {
    dispatch(
      actions.claimVoucherStep2({
        action: "claimvoucher_step2",
        companycode: companyCode,
        voucherid: settingState.voucherStep1.voucherid,
        promotionid: settingState.voucherStep1.promotionid,
      })
    ).then((resp) => {
      resp = resp.data;

      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage({ id: "voucherClaimSuccessfully" }),
          onConfirm: () => {
            setIsShow(false);
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  return (
    <Modal
      onHide={() => setIsShow(false)}
      show={isShow}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      data-bs-theme="dark"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="text-white">
          {intl.formatMessage({ id: "voucher" })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-white d-flex flex-column gap-2">
        {settingState.actionsLoading && <Overlay />}
        <div className="small">
          {intl.formatMessage({ id: "enterYourVoucher" })}
        </div>
        <div className="d-flex mb-4">
          <div className="flex-fill">
            <input
              className="form-control py-2 rounded-end-0"
              value={voucherCode}
              onChange={(e) => setVoucherCode(e.target.value)}
              placeholder={intl.formatMessage({ id: "voucherCode" })}
            />
          </div>
          <button
            className="btn btn-prim py-2 rounded-start-0"
            disabled={settingState.actionsLoading || settingState.searchLoading}
            onClick={onClaim}
          >
            {intl.formatMessage({ id: "claim" })}
          </button>
        </div>
        {settingState.searchLoading ? (
          <div className="d-flex align-items-center justify-content-center">
            <div className="spinner-border text-warning" role="status">
              <span class="sr-only"></span>
            </div>
          </div>
        ) : (
          settingState.voucherStep1 && (
            <>
              {settingState.voucherStep1.code === "0" ? (
                <div className="d-flex flex-column gap-2">
                  {settingState.voucherStep1.voucherCompanyLists.length > 0
                    ? settingState.voucherStep1.voucherCompanyLists.map(
                        (voucherCompany) => (
                          <div
                            key={voucherCompany.companyCode}
                            className="border rounded shadow-lg p-2"
                            onClick={() =>
                              handleVoucherClick(voucherCompany.companycode)
                            }
                          >
                            <div className="fw-bold">
                              {voucherCompany.companyname}
                            </div>
                            <div className="d-flex">
                              <div className="pe-2">
                                {intl.formatMessage({ id: "type" })} :
                              </div>
                              <div>
                                {voucherCompany.voucherCompanyTypes
                                  ?.map(
                                    (voucherCompanyType) =>
                                      voucherCompanyType.gametype
                                  )
                                  .join(",")}
                              </div>
                            </div>
                          </div>
                        )
                      )
                    : intl.formatMessage({ id: "noRecordFound" })}
                </div>
              ) : (
                <div>{settingState.voucherStep1.message}</div>
              )}
            </>
          )
        )}
      </Modal.Body>
    </Modal>
  );
};
